export enum NEWS_STATUS {
  ACTIVE    = 'ACTIVE',
  INACTIVE  = 'INACTIVE',
}

export enum NEWS_TYPES {
  GENERAL = 'GENERAL',
  COVID19 = 'COVID 19',
  IOTA    = 'IOTA',
}

export enum USER_ROLES {
  SYSTEMS       = "SISTEMAS",
  ADMIN         = "ADMIN",
  SUPER_ADMIN   = "SUPER_ADMIN",
  COMUNICATIONS = "COMUNICACIONES",
  SECRETARY     = "SECRETARIA",
}

export enum PLENARY_DOCS_STATUS {
  ACTIVE    = 'ACTIVO',
  INACTIVE  = 'INACTIVO',
}

export enum PLENARY_DOCS_TYPES {
  RESOLUTIONS     = 'RESOLUCIONES',
  DECLARATIONS    = 'DECLARACIONES',
  PRONOUNCEMENTS  = 'PRONUNCIAMIENTOS',
  PROCEEDINGS     = 'ACTAS',
  REPORTS         = 'INFORMES',
}

export enum PARLACEN_TV_STATUS {
  ACTIVE    = 'ACTIVO',
  INACTIVE  = 'INACTIVO',
}

export enum USER_STATUS {
  ACTIVE    = 'ACTIVO',
  INACTIVE  = 'INACTIVO',
}
export enum AGEND_STATUS {
  ACTIVE    = 'ACTIVO',
  INACTIVE  = 'INACTIVO',
}
export enum COUNTRY_TYPES {
  GUATEMALA     = 'Guatemala',
  ELSALVADOR    = 'El Salvador',
  HONDURAS      = 'Honduras',
  NICARAGUA     = 'Nicaragua',
  PANAMA        = 'Panamá',
  RPDOMINICANA  = 'República Dominicana',
  COSTA_RICA    = 'Costa Rica'
}
export enum POSITION_TYPES {
  PRESIDENTE        = 'Presidente',
  PRESIDENTA        = 'Presidenta',
  VICEPRESIDENTE    = 'Vice-Presidente',
  VICEPRESIDENTA    = 'Vice-Presidenta',
  SECRETARIO        = 'Secretario',
  SECRETARIA        = 'Secretaria',
  TESORERO          = 'Tesorero',
  TESORERA          = 'Tesorera',
  VOCAL             = 'Vocal',
  INTEGRANTE        = 'Integrante',
}

export enum POSITION_TYPES_B {
  PRESIDENTE        = 'Presidente',
  PRESIDENTA        = 'Presidenta',
  VICEPRESIDENTE    = 'Vice-Presidente',
  VICEPRESIDENTA    = 'Vice-Presidenta',
  SECRETARIO        = 'Secretario',
  SECRETARIA        = 'Secretaria'
}
export enum GP_TYPES {
  GPICD             = 'Grupo Parlamentario Integración Centro Democrático, GPICD',
  GPI               = 'Grupo Parlamentario De Izquierda, GPI',
  UDI               = 'Unidad Democrática Integracionista, UDI',
  NO                = 'Ninguno',
}
export enum COMMISSIONS {
  CDAPAYRN          = 'Comisión De Asuntos Agropecuarios, Pesca, Ambiente y Recursos Naturales',
  CDAJEIR           = 'Comisión De Asuntos Jurídicos e Institucionalidad Regional',
  CDDMYPC           = 'Comisión De Desarrollo Municipal y Participación Ciudadana',
  CDECDCYT          = 'Comisión De Educación, Cultura, Deporte, Ciencia y Tecnología',
  CDICYDE           = 'Comisión De Integración, Comercio y Desarrollo Económico',
  CDLMNJYF          = 'Comisión De La Mujer, Niñez, Juventud y Familia',
  CDMEYF            = 'Comisión De Macroeconomía y Finanzas',
  CDPIYA            = 'Comisión De Pueblos Indígenas y Afrodescendientes',
  CDRIYAM           = 'Comisión De Relaciones Internacionales y Asuntos Migratorios',
  CDSSSPYALYG       = 'Comisión De Salud, Seguridad Social, Población y Asuntos Laborales y Gremiales',
  CDSCPYDH          = 'Comisión De Seguridad Ciudadana, Paz y Derechos Humanos',
  CDT               = 'Comisión De Turismo',
  CPYDAP            = 'Comisión Política y De Asuntos Partidarios',
  CDGI              = 'Comisión De Gestión Institucional',
}
